import convertBytesToHumanReadable from "human-readable-bytes"

const humanFileSize = bytes => (bytes ? convertBytesToHumanReadable(bytes, 1024, 2, true) : null)

export default humanFileSize
